import { faApple } from "@fortawesome/free-brands-svg-icons";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import qs from "query-string";
import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { ReactComponent as MobileIcon } from "../../assets/icon/mobile-icon.svg";
import { ReactComponent as TabletIcon } from "../../assets/icon/tablet-icon.svg";
import ConditionalFragment from "../General/ConditionalFragment";
import Modal from "../General/Modal/Modal";

enum Platform {
  tablet = "平板",
  mobile = "手機",
}

const WelcomeNewer = () => {
  const { location, replace } = useHistory();

  const queryParams = qs.parse(location.search, { parseBooleans: true });
  const isNew = queryParams["is-new"];

  const onCloseClick = useCallback(() => {
    const _queryParams = JSON.parse(JSON.stringify(queryParams));
    delete _queryParams["is-new"];
    qs.stringify(_queryParams);
    replace(
      `${location.pathname}?${qs.stringify(_queryParams)}`,
      location.state
    );
  }, [queryParams, location, replace]);

  if (!isNew) return null;

  return (
    <Modal>
      <div
        className={classNames(
          "flex items-center justify-center",
          "px-8 py-[4rem]",
          "w-screen h-screen"
        )}
      >
        <div
          className={classNames(
            "relative",
            "mx-auto",
            "p-6 pt-[3.375rem] md:p-12 md:pt-[3.375rem]",
            "w-full max-h-full max-w-[20rem] md:max-w-[37.5rem] md:max-h-[42rem]",
            "bg-white rounded-lg",
            "overflow-scroll"
          )}
        >
          <CloseButton onClick={onCloseClick} />
          <p
            className={classNames("mb-4", "text-2xl font-semibold text-center")}
          >
            歡迎加入夯客
          </p>
          <p
            className={classNames(
              "mb-8 md:mb-10",
              "text-base text-center text-[#4A4E57]"
            )}
          >
            恭喜您註冊完成
            <br />
            下載夯客APP，開始免費試用
          </p>
          <Card
            platform={Platform.tablet}
            color={"primary"}
            link={
              "https://apps.apple.com/tw/app/hunger%E5%A4%AF%E5%AE%A2/id1505334363"
            }
          />
          <Card
            platform={Platform.mobile}
            color={"purple"}
            link={
              "https://apps.apple.com/tw/app/hunger%E5%A4%AF%E5%AE%A2-lite/id1619091476"
            }
          />
        </div>
      </div>
    </Modal>
  );
};

export default WelcomeNewer;

const CloseButton: React.FC<ElementPropsWithoutRef<"button">> = ({
  className,
  ...props
}) => {
  return (
    <button
      type={"button"}
      {...props}
      className={classNames(
        className,
        "absolute top-3 right-6",
        "text-grey-3 text-2xl"
      )}
    >
      <FontAwesomeIcon icon={faTimes} />
    </button>
  );
};

const Card: React.FC<{
  platform: Platform;
  color: string;
  link: string;
}> = ({ platform, color, link }) => {
  return (
    <div
      className={classNames(
        "relative",
        "mb-4 last:mb-0 md:mb-6",
        "p-6 pt-12 md:p-8 md:pt-12",
        "w-full",
        "border border-solid border-[#C7CaD1]",
        "rounded-xl"
      )}
    >
      <span
        className={classNames(
          "absolute top-[-1px]",
          "px-4 py-1.5",
          "text-white",
          "rounded-b-2xl",
          {
            "bg-primary-pink": color === "primary",
            "bg-purple": color === "purple",
          }
        )}
      >
        {platform}
      </span>
      <div className={"md:flex md:items-center"}>
        <div className={"hidden invisible md:block md:visible md:mr-8"}>
          <ConditionalFragment condition={platform === Platform.tablet}>
            <TabletIcon />
          </ConditionalFragment>
          <ConditionalFragment condition={platform === Platform.mobile}>
            <MobileIcon />
          </ConditionalFragment>
        </div>
        <div className={"md:flex-1"}>
          <a
            href={link}
            rel={"noopener noreferrer"}
            target={"_blank"}
            className={classNames(
              "block",
              "py-2 px-[1.125rem]",
              "mb-4",
              "w-full",
              "text-center",
              "border border-solid rounded-[999px]",
              {
                "text-primary-pink border-primary-pink": color === "primary",
                "text-purple border-purple": color === "purple",
              }
            )}
          >
            <span className={"text-base leading-[2rem]"}>
              <FontAwesomeIcon icon={faApple} className={"mr-2"} />
              前往 App Store 下載
            </span>
          </a>
          <p className={"text-sm text-[#4A4E57] text-center"}>
            目前僅支援 iOS 系統
          </p>
        </div>
      </div>
    </div>
  );
};
